<template>
  <div class="form-horizontal">
    <div class="form-group row">
      <label class="col-md-3 control-label">账户</label>
      <div class="col-md-9">
        <input class="form-control" v-model="username" disabled />
      </div>
    </div>

    <div class="form-group row">
      <label class="col-md-3 control-label">密码</label>
      <div class="col-md-9">
        <input type="password" class="form-control" v-model="pwd" />
      </div>
    </div>

    <div class="form-group row">
      <label class="col-md-3 control-label">新手机号</label>
      <div class="col-md-9">
        <input class="form-control" v-model="phone" />
      </div>
    </div>

    <div class="form-group row">
      <label class="col-md-3 control-label">图形验证码</label>
      <div class="col-md-5">
        <input
          type="text"
          class="form-control"
          placeholder="请输入图形验证码"
          aria-describedby="basic-addon1"
          v-model="captcha"
        />
      </div>
      <div class="col-md-4">
        <!--          <button type="submit" class="btn btn-default form-control sub" @click="getRandomImage" v-if="!imageCode">获取验证码</button>-->
        <p
          style="margin-top: 10px; cursor: pointer"
          @click="getRandomImage"
          v-if="!imageCode"
        >
          点击获取
        </p>
        <img :src="imageCode" v-else @click="getRandomImage" />
      </div>
    </div>

    <div class="form-group row">
      <label class="col-md-3 control-label">手机验证码</label>
      <div class="col-md-5">
        <input
          class="form-control border"
          v-model="phoneVerifyCode"
          placeholder="请输入手机验证码"
        />
      </div>
      <div class="col-md-4">
        <button
          type="button"
          class="btn-default form-control sub"
          @click="getSmsVerifyCode"
          :disabled="smsDisabled"
        >
          {{ smsMessage }}
        </button>
      </div>
    </div>
  </div>
</template>

<style>
.bind_tel_from {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.bind_tel_title {
  position: absolute;
  left: 50%;
  //top: 50%;
  //transform: translate(-50%,-50%);
  transform: translate(-50%);
}
</style>

<script>
export default {
  name: "ChangeBindTel",
  props: ["id", "username"],
  data: function () {
    return {
      userInfo: null,
      randomCode: null,
      imageCode: `/static/images/checkcode.png`,
      phone: "",
      captcha: "",
      phoneVerifyCode: "",
      smsDisabled: false,
      smsMessage: `获取短信验证码`,
      pwd: "",
    };
  },
  created() {},
  mounted() {
    const number = parseInt(Math.random(1) * Math.pow(10, 10));
    this.randomCode = number;
    this.getRandomImage();
  },
  methods: {
    // 获取图形验证码
    getRandomImage() {
      this.axios.get(`/sys/randomImage/${this.randomCode}`).then((res) => {
        this.imageCode = res.result;
      });
    },

    // 获取短信验证码
    getSmsVerifyCode() {
      const myregPhone = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
      if (!this.phone) {
        this.$message.warning("请输入手机号");
        return false;
      } else if (!myregPhone.test(this.phone)) {
        this.$message.warning("手机号格式不正确");
        return false;
      }
      if (!this.captcha) {
        this.$message.warning("请输入图形验证码");
        return;
      }
      // this.countdown(15);
      this.axios
        .get(`/biz/user/phone/verify/code`, {
          params: {
            captcha: this.captcha,
            checkKey: this.randomCode,
            mobile: this.phone,
          },
        })
        .then((res) => {
          if (res.success) {
            this.$message.success("发送成功");
            this.countdown(60);
          } else {
            this.getRandomImage();
          }
        })
        .catch(() => {
          this.getRandomImage();
        });
    },

    // 确定
    submit() {
      if (!this.pwd) {
        this.$message.warning("请输入密码");
        return;
      }
      const myregPhone = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
      if (!this.phone) {
        this.$message.warning("请输入手机号");
        return false;
      } else if (!myregPhone.test(this.phone)) {
        this.$message.warning("手机号格式不正确");
        return false;
      }
      if (!this.captcha) {
        this.$message.warning("请输入图形验证码");
        return;
      }
      if (!this.phoneVerifyCode) {
        this.$message.warning("请输入短信验证码");
        return;
      }
      this.axios
        .get(`/biz/user/phone/bind`, {
          params: {
            mobile: this.phone,
            pwd: this.pwd,
            code: this.phoneVerifyCode,
            type: 1
          },
        })
        .then((res) => {
          if (res.success) {
            const params = {
              id: this.id,
              phone: this.phone,
            };
            this.axios.put("/biz/archive/stuEdit", params).then((res) => {
              if (res.success) {
                this.axios.get("/sys/login/userinfo").then((res) => {
                  let userInfo = res.result.userInfo;
                  userInfo.eduLogo = res.result.eduLogo || null;
                  userInfo.headTitle =
                    res.result.headTitle
                  this.common.setStorage("userInfo", userInfo);
                  this.$store.commit("SET_USERINFO", userInfo);
                });
                this.$message.success("修改成功");
                this.$emit("toggle-modal", false);
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 倒计时
    countdown(index) {
      let countdownData = index;
      this.smsDisabled = true;

      if (this.timer) {
        clearInterval(this.timer);
      }

      this.timer = setInterval(() => {
        if (countdownData >= 0) {
          this.smsMessage = `${countdownData}秒后重试`;
          countdownData--;
        } else {
          this.smsMessage = `获取短信验证码`;
          this.smsDisabled = false;
          clearInterval(this.timer);
        }
      }, 1000);
    },
  }, // methods end
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.border-none {
  border: 0;
}

input {
  border: 1px solid #f2f2f2;
}

  .row {
    width: 500px;
    margin: 0 auto;
  }

  .col-md-4 {
    padding-right: 0;
  }

  label {
    margin-top: 10px;
    color: #999;
  }

  h1 {
    border-bottom: 1px solid #efefef;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .btn {
    background: $bgColor;
    color: #fff;
    width: 80px;
  }

  .form-group {
    margin-bottom: 20px;
  }

  .form-horizontal{
    background:#fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/noneTelBind.vue